<div class="row custom-div-h" [ngStyle]="{ '--img': 'url(' + randomImage + ')' } " [class.loaded]="imageLoaded">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        @if(step == 0){
            <mat-card appearance="outlined" class="card-ficha animate__faster animate__animated animate__fadeIn">
                <div class="logo-card" >
                    <img src="/logo/simpli-azul.svg"/>
                </div>
                <mat-card-header class="card-header">
                    <mat-card-title class="title">
                        ¡Te damos la bienvenida!
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>

                    <div class="subtitulo-card">
                        Para continuar, necesitamos que nos indiques si eres persona natural o persona jurídica.
                    </div>

                    <div>
                        <mat-radio-group
                            class="example-radio-group"
                            [(ngModel)]="opcion_seleccionada">
                            @for (tipo of tipo_persona; track tipo) {
                                <mat-radio-button class="example-radio-button" [value]="tipo">{{tipo}}</mat-radio-button>
                            }
                        </mat-radio-group>
                    </div>

                    <div class="button-card">
                        <button (click)="continuar()" mat-stroked-button class="primary-button" [disabled]="opcion_seleccionada == ''">
                            Continuar
                        </button>
                    </div>


                </mat-card-content>
            </mat-card>
        }

        @if(step === 1){
            <mat-card appearance="outlined" class="card-ficha animate__faster animate__animated animate__fadeIn">
                <div class="logo-card" >
                    <img src="/logo/simpli-azul.svg"/>
                </div>
                <mat-card-header class="card-header">
                    <mat-card-title class="title">
                        @if(substep == 1){
                            Datos personales
                        }

                        @if(substep == 2){
                            Información laboral
                        }

                        @if(substep == 3){
                            Datos bancarios
                        }

                        @if(substep == 4){
                           Origen de los fondos 
                        }

                        @if(substep == 5){
                           Declaración jurada
                        }
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>

                    <div class="subtitulo-card">
                        @if(substep >= 0 && substep < 5){
                            Completa el formulario con tus datos
                        }@else if(substep == 5){
                            Declaraciones bajo juramento
                        }@else {
                            Seleccione el origen de los fondos
                        }
                        
                    </div>

                    @if(substep == 1){

                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="formGroup">
                                <div class="row">

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">


                                        <mat-form-field appearance="fill">
                                            <mat-label>RUT</mat-label>
                                            <input matInput type="text" required formControlName="rut" (keyup)="rutKeyNatural($event)" (change)="checkRutNatural($event)">
                                            @if (display_spinner) {
                                                <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                                            }
                                            <mat-hint>Ingresa tu RUT</mat-hint>
                                            @if (formGroup.controls['rut'].hasError('required') && (formGroup.controls['rut'].dirty || formGroup.controls['rut'].touched)) {
                                                <mat-error>
                                                    Este campo es <strong>obligatorio</strong>
                                                </mat-error>
                                            }
                                            @if (formGroup.controls['rut'].hasError('invalid') || formGroup.controls['rut'].hasError('pattern')) {
                                                <mat-error>El RUT ingresado no es válido</mat-error>
                                            }

                                            @if(formGroup.controls['rut'].hasError('incorrect')) {
                                                <mat-error>
                                                    Este RUT ya esta en uso.
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Estado civil</mat-label>

                                            <mat-select formControlName="estado_civil">
                                                <mat-option *ngFor="let i of estado_civil_array" [value]="i.id">{{i.descripcion}}</mat-option>
                                            </mat-select>
                                            <mat-hint>Selecciona tu estado civil</mat-hint>
                                            @if(formGroup.controls['estado_civil'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Nombre completo</mat-label>
                                            <input matInput formControlName="name">
                                            <mat-hint>Ingresa tu nombre completo</mat-hint>
                                            @if(formGroup.controls['name'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                        <mat-label>Fecha nacimiento</mat-label>
                                        <input matInput [matDatepicker]="picker" (click)="picker.open()" readonly formControlName="fecha_nacimiento">
                                        <mat-hint>Selecciona tu fecha de nacimiento</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        @if(formGroup.controls['fecha_nacimiento'].hasError('required')) {
                                        <mat-error>
                                        Este campo es requerido.
                                        </mat-error>
                                        }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Nacionalidad</mat-label>

                                            <mat-select formControlName="nacionalidad">
                                                <mat-option value="argentina">Argentina</mat-option>
                                                <mat-option value="bolivia">Bolivia</mat-option>
                                                <mat-option value="brasil">Brasil</mat-option>
                                                <mat-option value="chile">Chile</mat-option>
                                                <mat-option value="colombia">Colombia</mat-option>
                                                <mat-option value="ecuador">Ecuador</mat-option>
                                                <mat-option value="guyana">Guyana</mat-option>
                                                <mat-option value="paraguay">Paraguay</mat-option>
                                                <mat-option value="peru">Perú</mat-option>
                                                <mat-option value="sudafrica">Sudáfrica</mat-option>
                                                <mat-option value="surinam">Surinam</mat-option>
                                                <mat-option value="uruguay">Uruguay</mat-option>
                                                <mat-option value="venezuela">Venezuela</mat-option>
                                            </mat-select>
                                            <mat-hint>Ingresa tu nacionalidad</mat-hint>
                                            @if(formGroup.controls['nacionalidad'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Correo electrónico</mat-label>
                                            <input matInput type="email" formControlName="email" (change)="validateEmail($event)">
                                            <mat-hint>Ingresa el email</mat-hint>
                                            @if (formGroup.controls['email'].hasError('email')) {
                                                <mat-error>
                                                    Email no es <strong>válido</strong>
                                                </mat-error>
                                            }
                                            @if(formGroup.controls['email'].hasError('required')) {
                                                <mat-error>
                                                    Este campo es requerido.
                                                </mat-error>
                                            }
                                            @if(formGroup.controls['email'].hasError('invalid')) {
                                                <mat-error>
                                                    Este correo ya esta en uso.
                                                </mat-error>
                                            }
                                            @if (spinner_validate_email) {
                                                <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                                            }
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="phone-field-wrapper">
                                        <mat-form-field appearance="outline" class="country-select-field">
                                            <mat-select formControlName="phone_code" 
                                                        (openedChange)="onSelectOpened($event)"
                                                        #countrySelect>
                                            <!-- Input de búsqueda nativo -->
                                            <div class="search-container" (click)="$event.stopPropagation()">
                                                <input 
                                                #searchInput
                                                class="search-input"
                                                placeholder="Código área"
                                                formControlName="countryFilterCtrl"
                                                (keydown)="$event.stopPropagation()"/>
                                            </div>

                                            <mat-option *ngFor="let country of filteredCountries" [value]="country.dialCode">
                                                <span class="flag">{{ country.flag }}</span>
                                                <span class="dial-code">{{ country.dialCode }}</span>
                                            </mat-option>

                                            <mat-option *ngIf="filteredCountries.length === 0" disabled>
                                                No se encontraron resultados
                                            </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" class="phone-number-field">
                                            <mat-label>Teléfono</mat-label>
                                            <input matInput type="tel" formControlName="phone_number"
                                                (input)="formatPhone($event)"
                                                placeholder="123 456 7890">
                                            <mat-hint>Ingresa el número sin código de país</mat-hint>
                                            @if(formGroup.controls['phone_number'].hasError('required')) {
                                            <mat-error>Este campo es requerido.</mat-error>
                                            }
                                        </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Región</mat-label>
                                            <mat-select formControlName="region_id">
                                            @for (region of regions; track $index) {
                                            <mat-option [value]="region.id">
                                                {{region.nombre}}
                                            </mat-option>
                                            }
                                            </mat-select>
                                            @if(formGroup.controls['region_id'].hasError('required') && formGroup.controls['region_id'].touched) {
                                                <mat-error>Este campo es requerido.</mat-error>
                                            } @else {
                                                <mat-hint>Seleccione la región del inversionista</mat-hint>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Comuna</mat-label>
                                            <mat-select formControlName="comuna_id">
                                                @for (district of filteredDistricts; track $index) {
                                                    <mat-option [value]="district.id">
                                                        {{ district.nombre }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if(formGroup.controls['comuna_id'].hasError('required') && formGroup.controls['comuna_id'].touched) {
                                                <mat-error>Este campo es requerido.</mat-error>
                                            } @else if (!formGroup.get('region_id')?.value) {
                                                <mat-hint>Seleccione la región primero</mat-hint>
                                            } @else {
                                                <mat-hint>Seleccione una comuna</mat-hint>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Dirección</mat-label>
                                            <input matInput formControlName="direccion">
                                            <mat-hint>Ingresa tu dirección</mat-hint>
                                            @if(formGroup.controls['direccion'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    

                                </div>
                            </form>

                        </div>

                    }

                    @if(substep == 2){

                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="formGroup2">
                                <div class="row">

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Profesión</mat-label>
                                            <input matInput formControlName="profesion">
                                            <mat-hint>Ingrese su profesión</mat-hint>
                                            @if(formGroup2.controls['profesion'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-top: 20px;">

                                        <div>Situación laboral</div>

                                        <mat-radio-group class="example-radio-group" formControlName="situacion_laboral">
                                            <mat-radio-button class="example-radio-button" [value]="0">Dependiente</mat-radio-button>
                                            <mat-radio-button class="example-radio-button" [value]="1">Independiente</mat-radio-button>
                                        </mat-radio-group>
                                        
                                    </div>

                                    <div *ngIf="formGroup2.controls['situacion_laboral'].value == 0" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Nombre de la empresa en que trabajas</mat-label>
                                            <input matInput formControlName="business_name">
                                            <mat-hint>Opcional</mat-hint>
                                        </mat-form-field>
                                    </div>



                                    

                                </div>
                            </form>
                        </div>

                    }

                    @if(substep == 3){
                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="formGroup3">
                                <div class="row">

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Banco</mat-label>
                                            <input type="text"
                                                matInput
                                                formControlName="banco_id"
                                                [matAutocomplete]="auto">
                                            <mat-autocomplete (optionSelected)="selecciono_banco($event)" autoActiveFirstOption [displayWith]="displayFn" #auto="matAutocomplete">
                                            @for (option of filteredOptions | async; track option) {
                                                <mat-option [value]="option">{{option.name}}</mat-option>
                                            }
                                            </mat-autocomplete>
                                            <mat-hint>Seleccione el banco</mat-hint>
                                            @if(formGroup3.controls['banco_id'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                        <mat-form-field appearance="fill">
                                            <mat-label>Tipo de cuenta</mat-label>
                                            <mat-select formControlName="cuenta_id" [compareWith]="compareFn">
                                                @for (i of cuentas; track i) {
                                                <mat-option [value]="i.id">{{i.name}}</mat-option>
                                                }
                                            </mat-select>
                                            @if(formGroup3.controls['cuenta_id'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                            <mat-hint>Seleccione el tipo de cuenta</mat-hint>
                                        </mat-form-field>
                                        
                                    </div>


                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Titular de la cuenta</mat-label>
                                            <input matInput formControlName="titular">
                                            <mat-hint>Ingresa el nombre del titular</mat-hint>
                                            @if(formGroup3.controls['titular'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>N° de cuenta</mat-label>
                                            <input matInput formControlName="numero_cuenta" (input)="soloNumerosCuenta()">
                                            <mat-hint>Ingresa el número de cuenta</mat-hint>
                                            @if(formGroup3.controls['numero_cuenta'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>RUT del titular</mat-label>
                                            <input matInput formControlName="rut" (change)="verify_tercero()" (input)="formatRUT3($event)">
                                            <mat-hint>Ingresa el RUT del titular</mat-hint>
                                            @if(formGroup3.controls['rut'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    @if(show_terceros == true){
                                        <div>
                                            <section class="example-section">
                                                <mat-checkbox formControlName="autorizar_terceros" class="example-margin">Autorizo transferencia a cuenta de terceros.</mat-checkbox>
                                            </section>
                                        </div>
                                    }


                                    

                                </div>
                            </form>
                        </div>
                    }

                    @if(substep == 4){
                        <div class="animate__faster animate__animated animate__fadeIn">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-top: 20px;">

                                    <section class="example-section" [formGroup]="formGroup4">
                                        <p><mat-checkbox formControlName="0">Ahorros personales</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="1">Sueldo o ingresos laborales</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="2">Venta de bienes</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="3">Herencia o donaciones</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="4">Rentas de inversiones</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="5">Otros</mat-checkbox></p>
                                    </section>
                                    
                                </div>
                        </div>
                    }

                    @if(substep == 5){
                        <div class="animate__faster animate__animated animate__fadeIn">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-top: 20px;">

                                    <section class="example-section" [formGroup]="formGroup5">
                                        <p><mat-checkbox formControlName="0">No soy una US Person, según la definición de la ley FATCA.</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="1">No soy una persona expuesta políticamente (<app-custom-popover
                                                [content]="popoverPEP"
                                                position="top"
                                                [hideDelay]="500"
                                                width="600px">
                                                    <span style="cursor: pointer;text-decoration: underline;color:blue">PEP</span>

                                            </app-custom-popover>) ni tengo vínculos con


                                            <app-custom-popover
                                                [content]="popoverPEP"
                                                position="top"
                                                [hideDelay]="500"
                                                width="600px">
                                                    <span style="cursor: pointer;text-decoration: underline;color:blue">PEP.</span>

                                            </app-custom-popover>
                                            
                                            </mat-checkbox></p>
                                        <p><mat-checkbox formControlName="2">Yo <strong>{{valForm2.controls['name'].value}}</strong> declaro que la información proporcionada es veraz y actualizada.</mat-checkbox></p>

                                    </section>
                                    
                                </div>
                        </div>
                    }


                    <div class="button-card">
                        <!--botonera persona natural-->
                        @if(substep == 1){

                            <button (click)="step = 0" mat-stroked-button class="secondary-button">
                                Volver
                            </button>

                            <button (click)="sendForm($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 2){
                            <button (click)="sendForm2($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 3){
                            <button (click)="sendForm3($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 4){
                            <button (click)="sendForm4()" [disabled]="continuar_origen" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 5){
                            <button (click)="finalizar()" [disabled]="continuar_declaracion" mat-stroked-button class="primary-button">
                                Finalizar
                            </button>
                        }
                    </div>


                </mat-card-content>
            </mat-card>
        }

        @if(step === 2){
            <mat-card appearance="outlined" class="card-ficha animate__faster animate__animated animate__fadeIn" [class.card-ficha-wide]="substep == 2">
                <div class="logo-card" >
                    <img src="/logo/simpli-azul.svg"/>
                </div>
                <mat-card-header class="card-header">
                    <mat-card-title class="title">
                        @if(substep == 1){
                            Datos de la empresa
                        }

                        @if(substep == 2){
                            Datos del representante legal
                        }

                        @if(substep == 3){
                            Información bancaria
                        }

                        @if(substep == 4){
                           Origen de los fondos 
                        }

                        @if(substep == 5){
                           Declaración jurada
                        }
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>

                    <div class="subtitulo-card">
                        @if(substep >= 0 && substep < 5){
                            Completa el formulario con los datos requeridos
                        }@else if(substep == 5){
                            Declaraciones bajo juramento
                        }@else {
                            Seleccione el origen de los fondos
                        }
                        
                    </div>

                    @if(substep == 1){

                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="valForm">
                                <div class="row">

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                        <mat-form-field appearance="fill">
                                            <mat-label>RUT</mat-label>
                                            <input matInput type="text" required formControlName="rut" (keyup)="rutKeyJuridico1($event)" (change)="checkRutJuridico($event)">
                                            @if (display_spinner) {
                                            <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                                            }
                                            <mat-hint>Ingresa tu RUT de Empresa sin puntos con guión</mat-hint>
                                            @if (valForm.controls['rut'].hasError('required') && (valForm.controls['rut'].dirty || valForm.controls['rut'].touched)) {
                                            <mat-error>
                                                Este campo es <strong>obligatorio</strong>
                                            </mat-error>
                                            }
                                            @if (valForm.controls['rut'].hasError('invalid') || valForm.controls['rut'].hasError('pattern')) {
                                            <mat-error>El RUT ingresado no es válido</mat-error>
                                            }
                                            @if(valForm.controls['rut'].hasError('incorrect')) {
                                                <mat-error>
                                                    Este RUT ya esta en uso.
                                                </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Razón social</mat-label>
                                            <input matInput formControlName="razon_social">
                                            <mat-hint>Ingresa la razón social de la empresa</mat-hint>
                                            @if(valForm.controls['razon_social'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Giro de la empresa</mat-label>
                                            <input matInput formControlName="giro">
                                            <mat-hint>Ingresa el giro de la empresa</mat-hint>
                                            @if(valForm.controls['giro'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Correo electrónico</mat-label>
                                            <input matInput type="email" formControlName="email" (change)="validateEmailJuridico($event.target.value)">
                                            <mat-hint>Ingresa el email</mat-hint>
                                            @if (valForm.controls['email'].hasError('email')) {
                                            <mat-error>
                                            Email no es <strong>válido</strong>
                                            </mat-error>
                                            }
                                            @if(valForm.controls['email'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                            @if(valForm.controls['email'].hasError('invalid')) {
                                                <mat-error>
                                                    Este correo ya esta en uso.
                                                </mat-error>
                                            }
                                            @if (spinner_validate_email) {
                                                <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                                            }
                                        </mat-form-field>
                                    </div> -->



                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Región</mat-label>
                                            <mat-select formControlName="region_empresa_id">
                                            @for (region of regions; track $index) {
                                            <mat-option [value]="region.id">
                                                {{region.nombre}}
                                            </mat-option>
                                            }
                                            </mat-select>
                                            @if(valForm.controls['region_empresa_id'].hasError('required') && valForm.controls['region_empresa_id'].touched) {
                                                <mat-error>Este campo es requerido.</mat-error>
                                            } @else {
                                                <mat-hint>Seleccione la región de la empresa</mat-hint>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Comuna</mat-label>
                                            <mat-select formControlName="comuna_empresa_id">
                                                @for (district of filteredDistrictsEmpresa; track $index) {
                                                    <mat-option [value]="district.id">
                                                        {{ district.nombre }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                            @if(valForm.controls['comuna_empresa_id'].hasError('required') && valForm.controls['comuna_empresa_id'].touched) {
                                                <mat-error>Este campo es requerido.</mat-error>
                                            } @else if (!valForm.get('region_empresa_id')?.value) {
                                                <mat-hint>Seleccione la región primero</mat-hint>
                                            } @else {
                                                <mat-hint>Seleccione una comuna</mat-hint>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Dirección</mat-label>
                                            <input matInput formControlName="direccion">
                                            <mat-hint>Ingresa tu dirección</mat-hint>
                                            @if(valForm.controls['direccion'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                </div>
                            </form>

                        </div>

                    }

                    @if(substep == 2){

                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="valForm2">
                                <div class="row">

                                    <!-- Columna izquierda: RUT → Cargo -->
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>RUT</mat-label>
                                                    <input matInput type="text" required formControlName="rut" (keyup)="rutKeyJuridico($event)">
                                                    @if (display_spinner) {
                                                    <mat-spinner color="primary" style="margin-right: 10px;" matSuffix diameter="20"></mat-spinner>
                                                    }
                                                    <mat-hint>Ingresa tu RUT sin puntos con guión</mat-hint>
                                                    @if (valForm2.controls['rut'].hasError('required') && (valForm2.controls['rut'].dirty || valForm2.controls['rut'].touched)) {
                                                    <mat-error>Este campo es <strong>obligatorio</strong></mat-error>
                                                    }
                                                    @if (valForm2.controls['rut'].hasError('invalid') || valForm2.controls['rut'].hasError('pattern')) {
                                                    <mat-error>El RUT ingresado no es válido</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Estado civil</mat-label>
                                                    <mat-select formControlName="estado_civil">
                                                        @for (i of estado_civil_array; track i.id) {
                                                            <mat-option [value]="i.id">{{i.descripcion}}</mat-option>
                                                        }
                                                    </mat-select>
                                                    <mat-hint>Selecciona tu estado civil</mat-hint>
                                                    @if(valForm2.controls['estado_civil'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Nombre completo</mat-label>
                                                    <input matInput formControlName="name">
                                                    <mat-hint>Ingresa tu nombre completo</mat-hint>
                                                    @if(valForm2.controls['name'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Fecha nacimiento</mat-label>
                                                    <input matInput [matDatepicker]="picker" (click)="picker.open()" readonly formControlName="fecha_nacimiento">
                                                    <mat-hint>Selecciona tu fecha de nacimiento</mat-hint>
                                                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>
                                                    @if(valForm2.controls['fecha_nacimiento'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>


                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Cargo</mat-label>
                                                    <input matInput formControlName="cargo">
                                                    <mat-hint>Ingresa tu cargo dentro de la empresa</mat-hint>
                                                    @if(valForm2.controls['cargo'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Profesión</mat-label>
                                                    <input matInput formControlName="profesion">
                                                    <mat-hint>Ingresa la profesión</mat-hint>
                                                    @if(valForm2.controls['profesion'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                        </div>
                                    </div>

                                    <!-- Columna derecha: Correo → Comuna -->
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div class="row">


                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Nacionalidad</mat-label>
                                                    <mat-select formControlName="nacionalidad">
                                                        <mat-option value="argentina">Argentina</mat-option>
                                                        <mat-option value="bolivia">Bolivia</mat-option>
                                                        <mat-option value="brasil">Brasil</mat-option>
                                                        <mat-option value="chile">Chile</mat-option>
                                                        <mat-option value="colombia">Colombia</mat-option>
                                                        <mat-option value="ecuador">Ecuador</mat-option>
                                                        <mat-option value="guyana">Guyana</mat-option>
                                                        <mat-option value="paraguay">Paraguay</mat-option>
                                                        <mat-option value="peru">Perú</mat-option>
                                                        <mat-option value="sudafrica">Sudáfrica</mat-option>
                                                        <mat-option value="surinam">Surinam</mat-option>
                                                        <mat-option value="uruguay">Uruguay</mat-option>
                                                        <mat-option value="venezuela">Venezuela</mat-option>
                                                    </mat-select>
                                                    <mat-hint>Ingresa tu nacionalidad</mat-hint>
                                                    @if(valForm2.controls['nacionalidad'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Correo electrónico</mat-label>
                                                    <input matInput type="email" formControlName="email">
                                                    <mat-hint>Ingresa el email</mat-hint>
                                                    @if (valForm2.controls['email'].hasError('email')) {
                                                    <mat-error>Email no es <strong>válido</strong></mat-error>
                                                    }
                                                    @if(valForm2.controls['email'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Dirección</mat-label>
                                                    <input matInput formControlName="direccion">
                                                    <mat-hint>Ingresa tu dirección</mat-hint>
                                                    @if(valForm2.controls['direccion'].hasError('required')) {
                                                    <mat-error>Este campo es requerido.</mat-error>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Región</mat-label>
                                                    <mat-select formControlName="region_id">
                                                    @for (region of regions; track $index) {
                                                    <mat-option [value]="region.id">{{region.nombre}}</mat-option>
                                                    }
                                                    </mat-select>
                                                    @if(valForm2.controls['region_id'].hasError('required') && valForm2.controls['region_id'].touched) {
                                                        <mat-error>Este campo es requerido.</mat-error>
                                                    } @else {
                                                        <mat-hint>Seleccione la región</mat-hint>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <mat-form-field appearance="fill">
                                                    <mat-label>Comuna</mat-label>
                                                    <mat-select formControlName="comuna_id">
                                                    @for (district of filteredDistrictsRepLegal; track $index) {
                                                    <mat-option [value]="district.id">{{ district.nombre }}</mat-option>
                                                    }
                                                    </mat-select>
                                                    @if(valForm2.controls['comuna_id'].hasError('required') && valForm2.controls['comuna_id'].touched) {
                                                        <mat-error>Este campo es requerido.</mat-error>
                                                    } @else if (!valForm2.get('region_id')?.value) {
                                                        <mat-hint>Seleccione la región primero</mat-hint>
                                                    } @else {
                                                        <mat-hint>Seleccione una comuna</mat-hint>
                                                    }
                                                </mat-form-field>
                                            </div>

                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="phone-field-wrapper">
                                                    <mat-form-field appearance="outline" class="country-select-field">
                                                        <mat-select formControlName="phone_code"
                                                                    (openedChange)="onSelectOpened2($event)"
                                                                    #countrySelect>
                                                            <div class="search-container" (click)="$event.stopPropagation()">
                                                                <input
                                                                #searchInput
                                                                class="search-input"
                                                                placeholder="Código área"
                                                                formControlName="countryFilterCtrl"
                                                                (keydown)="$event.stopPropagation()"/>
                                                            </div>
                                                            @for (country of filteredCountries; track country.dialCode) {
                                                                <mat-option [value]="country.dialCode">
                                                                    <span class="flag">{{ country.flag }}</span>
                                                                    <span class="dial-code">{{ country.dialCode }}</span>
                                                                </mat-option>
                                                            }
                                                            @if (filteredCountries.length === 0) {
                                                                <mat-option disabled>No se encontraron resultados</mat-option>
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" class="phone-number-field">
                                                        <mat-label>Teléfono</mat-label>
                                                        <input matInput type="tel" formControlName="phone_number"
                                                            (input)="formatPhone($event)"
                                                            placeholder="123 456 7890">
                                                        <mat-hint>Ingresa el número sin código de país</mat-hint>
                                                        @if(valForm2.controls['phone_number'].hasError('required')) {
                                                        <mat-error>Este campo es requerido.</mat-error>
                                                        }
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>

                    }

                    @if(substep == 3){
                        <div class="animate__faster animate__animated animate__fadeIn">
                            <form [formGroup]="formGroup3">
                                <div class="row">

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Banco</mat-label>
                                            <input type="text"
                                                matInput
                                                formControlName="banco_id"
                                                [matAutocomplete]="auto">
                                            <mat-autocomplete (optionSelected)="selecciono_banco($event)" autoActiveFirstOption [displayWith]="displayFn" #auto="matAutocomplete">
                                            @for (option of filteredOptions | async; track option) {
                                                <mat-option [value]="option">{{option.name}}</mat-option>
                                            }
                                            </mat-autocomplete>
                                            <mat-hint>Seleccione el banco</mat-hint>
                                            @if(formGroup3.controls['banco_id'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                        <mat-form-field appearance="fill">
                                            <mat-label>Tipo de cuenta</mat-label>
                                            <mat-select formControlName="cuenta_id" [compareWith]="compareFn">
                                                @for (i of cuentas; track i) {
                                                <mat-option [value]="i.id">{{i.name}}</mat-option>
                                                }
                                            </mat-select>
                                            @if(formGroup3.controls['cuenta_id'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                            <mat-hint>Seleccione el tipo de cuenta</mat-hint>
                                        </mat-form-field>
                                        
                                    </div>


                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Titular de la cuenta</mat-label>
                                            <input matInput formControlName="titular">
                                            <mat-hint>Ingresa el nombre del titular</mat-hint>
                                            @if(formGroup3.controls['titular'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>N° de cuenta</mat-label>
                                            <input matInput formControlName="numero_cuenta" (input)="soloNumerosCuenta()">
                                            <mat-hint>Ingresa el número de cuenta</mat-hint>
                                            @if(formGroup3.controls['numero_cuenta'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>


                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <mat-form-field appearance="fill">
                                            <mat-label>RUT del titular</mat-label>
                                            <input matInput formControlName="rut" (change)="verify_tercero()" (input)="formatRUT3($event)">
                                            <mat-hint>Ingresa el RUT del titular</mat-hint>
                                            @if(formGroup3.controls['rut'].hasError('required')) {
                                            <mat-error>
                                            Este campo es requerido.
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>

                                    @if(show_terceros == true){
                                        <div>
                                            <section class="example-section">
                                                <mat-checkbox formControlName="autorizar_terceros" class="example-margin">Autorizo transferencia a cuenta de terceros.</mat-checkbox>
                                            </section>
                                        </div>
                                    }


                                    

                                </div>
                            </form>
                        </div>
                    }

                    @if(substep == 4){
                        <div class="animate__faster animate__animated animate__fadeIn">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-top: 20px;">

                                    <section class="example-section" [formGroup]="valForm4">
                                        <p><mat-checkbox formControlName="0">Ventas o ingresos de la empresa</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="1">Capitalización de socios</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="2">Préstamos o financiamiento</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="3">Rentas de inversiones</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="4">Otros</mat-checkbox></p>
                                    </section>
                                    
                                </div>
                        </div>
                    }

                    @if(substep == 5){
                        <div class="animate__faster animate__animated animate__fadeIn">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="text-align: center;margin-top: 20px;">

                                    <section class="example-section" [formGroup]="formGroup5">
                                        <p><mat-checkbox formControlName="0">No soy una US Person, según la definición de la ley FATCA.</mat-checkbox></p>
                                        <p><mat-checkbox formControlName="1">No soy una persona expuesta políticamente (<app-custom-popover
                                                [content]="popoverPEP"
                                                position="top"
                                                [hideDelay]="500"
                                                width="600px">
                                                    <span style="cursor: pointer;text-decoration: underline;color:blue">PEP</span>

                                            </app-custom-popover>) ni tengo vínculos con


                                            <app-custom-popover
                                                [content]="popoverPEP"
                                                position="top"
                                                [hideDelay]="500"
                                                width="600px">
                                                    <span style="cursor: pointer;text-decoration: underline;color:blue">PEP.</span>

                                            </app-custom-popover>
                                            
                                            </mat-checkbox></p>
                                        <p><mat-checkbox formControlName="2">Yo <strong>{{valForm2.controls['name'].value}}</strong> declaro que la información proporcionada es veraz y actualizada.</mat-checkbox></p>

                                    </section>



                                </div>
                        </div>
                    }


                    <div class="button-card">
                        @if(substep == 1){

                            <button (click)="step = 0" mat-stroked-button class="secondary-button">
                                Volver
                            </button>

                            <button (click)="sendFormJuridico($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 2){
                            <button (click)="sendFormJuridico2($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 3){
                            <button (click)="sendFormJuridico3($event)" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 4){
                            <button (click)="sendForm4()" [disabled]="continuar_origen" mat-stroked-button class="primary-button">
                                Continuar
                            </button>
                        }

                        @if(substep == 5){
                            <button (click)="finalizar_juridico()" [disabled]="continuar_declaracion" mat-stroked-button class="primary-button">
                                Finalizar
                            </button>
                        }
                    </div>


                </mat-card-content>
            </mat-card>
        }

        @if(step == 3){
            <mat-card appearance="outlined" class="card-ficha animate__faster animate__animated animate__fadeIn">
                <div class="logo-card" >
                    <img src="/logo/simpli-azul.svg"/>
                </div>
                <mat-card-header class="card-header">
                    <mat-card-title class="title">
                        ¡Felicidades, formulario completado!
                    </mat-card-title>
                </mat-card-header>

                <mat-card-content>

                    <div class="check-box-card">

                        <span class="material-icons">
                        check_circle
                        </span>

                    </div>

                    <div class="subtitulo-card" style="margin-top: 40px;margin-bottom: 60px;">
                        Se recibió con éxito la información, muy pronto seras contactado por nuestro equipo de inversiones, ya puedes abandonar esta página.
                    </div>




                </mat-card-content>
            </mat-card>
        }


    </div>
</div>